import Snippet from '../../components/Snippet/Snippet'
import { btnRep, button, input, size, a } from '../../assets/code-snippets/button/snip'

const Button = () => {

    return <div className="container fluid py-2" id="intro">

        <div className="container fluid">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Button styling </p>
            <p className="text md">3 main tag elements can be styled in POKE-CSS as buttons: <code className="primary"> a, input, button</code>. </p>
        </div>

        <p className="text md">Classes available for <code>a, input & button</code> tag elements: </p>
        <div className="container xl">
            <div className="table" padding="2" cell-spacing="3" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Tag Element</th>
                            <th>Class</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><code>a, input & button</code></td>
                            <td><code>.btn.sm, .btn.md, .btn.lg, .btn.xl</code>
                            </td>
                            <td>Sets the button size, font size & padding</td>
                        </tr>
                        <tr>
                            <td><code>a, input & button</code></td>
                            <td><code>.btn.sm.wide, .btn.md.wide, .btn.lg.wide,
                                .btn.xl.wide</code>
                            </td>
                            <td>Sets the button size, font size & padding, makes the button full
                            width</td>
                        </tr>
                        <tr>
                            <td><code>a, input & button</code></td>
                            <td><code>.btn.dark, .btn.light, .btn.primary, .btn.success,
                            .btn.warning, .btn.info, .btn.danger,
                                .btn.secondary</code>
                            </td>
                            <td>Sets the button color style</td>
                        </tr>
                        <tr>
                            <td><code>a, input & button</code></td>
                            <td><code>.btn.outline.dark, .btn.outline.light, .btn.outline.primary,
                            .btn.outline.success, .btn.outline.warning,
                            .btn.outline.info,
                            .btn.outline.danger,
                                .btn.outline.secondary</code>
                            </td>
                            <td>Sets the <code>inset</code> box shadow and also text color</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="spacer md"></div>
        <p className="text lg">A simple example:</p>

        <div className="row align-items-center">
            <div className="col md-III">
                <div className="container sm">
                    <Snippet code={btnRep} language='html' />
                </div>
            </div>
            <div className="col md-III">
                <div className="container sm">
                    <div className="row">
                        <button className="btn">button</button>
                        <button className="btn dark">button</button>
                        <button className="btn outline">button</button>
                        <button className="btn lg">button</button>
                        <button className="btn wide">button</button>
                    </div>
                </div>
            </div>
        </div>

        <div className="spacer md"></div>

        <div className="container">

            <div className="container fluid py-2" id="a">

                <div className="container fluid">
                    <p className="text xl"><a href="#a" className="link">&#128279;</a> <code>a</code> tag </p>
                    <p className="text md gray"></p>
                </div>

                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="container sm">
                            <Snippet code={a} language='html' />
                        </div>
                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <a href='/' className="btn md dark">link</a>
                            <a href='/' className="btn md light">link</a>
                            <a href='/' className="btn md success">link</a>
                            <a href='/' className="btn md danger">link</a>
                            <a href='/' className="btn md info">link</a>
                            <a href='/' className="btn md primary">link</a>
                            <a href='/' className="btn md warning">link</a>
                            <a href='/' className="btn md secondary">link</a>
                        </div>
                    </div>
                </div>
            </div>


            <div className="container fluid py-2" id="input">
                <div className="container fluid">
                    <p className="text xl"><a href="#input" className="link">&#128279;</a> <code>input</code> tag </p>
                </div>

                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="container md">
                            <Snippet code={input} language='html' />
                        </div>
                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <input type="button" value="input" className="btn md dark" />
                            <input type="button" value="input" className="btn md light" />
                            <input type="button" value="input" className="btn md success" />
                            <input type="button" value="input" className="btn md danger" />
                            <input type="button" value="input" className="btn md info" />
                            <input type="button" value="input" className="btn md primary" />
                            <input type="button" value="input" className="btn md warning" />
                            <input type="button" value="input" className="btn md secondary" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container fluid py-2" id="button">
                <div className="container fluid">
                    <p className="text xl"><a href="#button" className="link">&#128279;</a> <code>button</code> tag </p>
                </div>

                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="container sm">
                            <Snippet code={button} language='html' />
                        </div>
                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <button className="btn md dark">button</button>
                            <button className="btn md light">button</button>
                            <button className="btn md success">button</button>
                            <button className="btn md danger">button</button>
                            <button className="btn md info">button</button>
                            <button className="btn md primary">button</button>
                            <button className="btn md warning">button</button>
                            <button className="btn md secondary">button</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container fluid py-2" id="sizes">
                <div className="container fluid">
                    <p className="text xl"><a href="#sizes" className="link">&#128279;</a> Button sizes </p>
                </div>

                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="container sm">
                            <Snippet code={size} language='html' />
                        </div>
                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <div className="row">
                                <button className="btn sm">button</button>
                                <button className="btn md">button</button>
                                <button className="btn lg">button</button>
                                <button className="btn xl">button</button>
                            </div>
                            <div className="spacer sm"></div>
                            <button className="btn sm wide">button</button>
                            <button className="btn md wide">button</button>
                            <button className="btn lg wide">button</button>
                            <button className="btn xl wide">button</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

}

export default Button